import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ServiceVariantModel} from '../../../../models/ServiceVariantModel';
import {ServiceVariantService} from '../../../general-services/service-service-variant-anagraf/service-variant.service';

@Component({
  selector: 'app-edit-service-variant-anagraf',
  templateUrl: './edit-service-variant-anagraf.component.html',
  styleUrls: ['./edit-service-variant-anagraf.component.scss']
})
export class EditServiceVariantAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  serviceVariant: ServiceVariantModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  serviceVariantCod: string;
  description: string;
  serviceVariantJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private serviceVariantService: ServiceVariantService, private _activatedRoute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.serviceVariantJson = params['row'];
      });

    this.serviceVariant = new ServiceVariantModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.serviceVariant = JSON.parse(this.serviceVariantJson) as ServiceVariantModel;

    this.formValidator.patchValue({
      cod: this.serviceVariant ? this.serviceVariant.cod : ''
    });

    this.formValidator.patchValue({
      description: this.serviceVariant ? this.serviceVariant.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.serviceVariantCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SERVICE_VARIANT_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.serviceVariant.cod = this.formValidator.controls['cod'].value;
      this.serviceVariant.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.serviceVariantService.update(this.serviceVariantService.baseUrl, this.serviceVariant).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Service Variant Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Service Variant was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SERVICE_VARIANT_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
